module.exports = __webpack_public_path__ + "static/b7ab293f.up.png";